import { SEC_AUTH_M_TK } from 'constants/AuthConstant';
import {
  ONBOARDING_COMPLETED_PREFIX,
  ONBOARDING_IN_PROGRESS_KEY,
  ONBOARDING_SESSION_FLAG,
} from 'constants/OnboardingConstant';
import { getUserIdFromToken, getUserEmailFromToken } from 'utils/jwtUtils';
import { safeGetToken } from 'utils/safeStorage';
import { shouldShowSignupAgentOnboarding } from './signupAgentOnboardingUtils';

export const getOnboardingUserKey = () => {
  const token = safeGetToken(SEC_AUTH_M_TK);
  const userId = getUserIdFromToken(token);
  const email = getUserEmailFromToken(token) || localStorage.getItem('_un');
  return userId || email || 'anonymous';
};

export const getOnboardingCompletedKey = () =>
  `${ONBOARDING_COMPLETED_PREFIX}${getOnboardingUserKey()}`;

export const hasCompletedOnboarding = () => {
  try {
    return localStorage.getItem(getOnboardingCompletedKey()) === 'true';
  } catch {
    return false;
  }
};

export const markOnboardingCompleted = () => {
  try {
    localStorage.setItem(getOnboardingCompletedKey(), 'true');
    sessionStorage.removeItem(ONBOARDING_SESSION_FLAG);
    sessionStorage.removeItem(ONBOARDING_IN_PROGRESS_KEY);
  } catch {
    // no-op
  }
};

export const hasOnboardingSessionFlag = () => {
  try {
    return sessionStorage.getItem(ONBOARDING_SESSION_FLAG) === 'true';
  } catch {
    return false;
  }
};

/** Show welcome tour only on the signup session, until the user completes or skips it. */
export const shouldShowPlatformOnboarding = () =>
  hasOnboardingSessionFlag() &&
  !hasCompletedOnboarding() &&
  !shouldShowSignupAgentOnboarding();

export const setOnboardingSessionFlag = () => {
  try {
    sessionStorage.setItem(ONBOARDING_SESSION_FLAG, 'true');
  } catch {
    // no-op
  }
};

export const setOnboardingInProgress = (active) => {
  try {
    if (active) {
      sessionStorage.setItem(ONBOARDING_IN_PROGRESS_KEY, 'true');
    } else {
      sessionStorage.removeItem(ONBOARDING_IN_PROGRESS_KEY);
    }
  } catch {
    // no-op
  }
};

export const isOnboardingInProgress = () => {
  try {
    return sessionStorage.getItem(ONBOARDING_IN_PROGRESS_KEY) === 'true';
  } catch {
    return false;
  }
};

export const clearOnboardingStorageForUser = () => {
  try {
    const prefix = ONBOARDING_COMPLETED_PREFIX;
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(prefix)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => localStorage.removeItem(key));
    sessionStorage.removeItem(ONBOARDING_SESSION_FLAG);
    sessionStorage.removeItem(ONBOARDING_IN_PROGRESS_KEY);
  } catch {
    // no-op
  }
};
